import { DYNAMIC_HOTEL_IMAGE_SIZE_LABEL } from '@constants/constants';

import {
  EitherRoomOrHotelFeaturesMeta,
  HotelFeaturesMeta,
  RoomFeaturesMeta,
} from '../components/details-galleries-modal/types';

export const getTypedFeatureProps = <
  DATA extends Pick<EitherRoomOrHotelFeaturesMeta, 'entityType' | 'features'>
>(
  data: DATA
) => {
  return data.entityType === 'hotel'
    ? (data as HotelFeaturesMeta)
    : (data as RoomFeaturesMeta);
};

export const cloudineryImage = (
  url,
  width,
  height,
  format = 'auto',
  qualty = 'auto'
) => {
  if (!url?.includes(DYNAMIC_HOTEL_IMAGE_SIZE_LABEL)) return url;
  return url?.replace(
    DYNAMIC_HOTEL_IMAGE_SIZE_LABEL,
    `${
      height ? `h_${height},` : ''
    }w_${width},q_${qualty}:best,f_${format},dpr_auto,e_sharpen:100`
  );
};
